import { render } from "./EmailForm.vue?vue&type=template&id=6e11df70&scoped=true"
import script from "./EmailForm.vue?vue&type=script&lang=js"
export * from "./EmailForm.vue?vue&type=script&lang=js"

import "./EmailForm.vue?vue&type=style&index=0&id=6e11df70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e11df70"]])

export default __exports__